import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {meltingTemperature, NucleotideType} from 'biojs/Util';
import {GRAY} from 'ui-library/Colors';
import {DEGREE_SIGN} from 'util/UnicodeSymbols';

export interface OligoMetadataProps {
  name: string;
  folderName: string;
  bases: string;
  nucleotideType: NucleotideType;
}

/**
 * A presentational component for showing oligo metadata, for use in dropdowns such as with ChipSearchInput.
 *
 * @param name Name of the oligo
 * @param folderName Name of the folder in which the oligo is located
 * @param bases Bases of the oligo
 * @param nucleotideType Nucleotide type (DNA/RNA) of the oligo
 */
function OligoMetadata({name, folderName, bases, nucleotideType}: OligoMetadataProps): JSX.Element {
  return (
    <div className={css(styles.oligoOptions)}>
      <div className={css(styles.namesContainer)}>
        <div>{name}</div>
        <div className={css(styles.folderName)}>{folderName}</div>
      </div>
      {bases && (
        <div className={css(styles.biologicalMetadataContainer)}>
          <span className={css(styles.biologicalMetadata)}>{`${bases.length}bp, ${meltingTemperature(
            bases,
            nucleotideType
          ).toFixed(1)}${DEGREE_SIGN}C`}</span>
        </div>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  folderName: {color: GRAY},
  biologicalMetadata: {color: GRAY, display: 'flex', alignItems: 'center'},
  oligoOptions: {display: 'flex', justifyContent: 'space-between'},
  biologicalMetadataContainer: {display: 'flex', flexBasis: '30%', justifyContent: 'flex-end'},
  namesContainer: {flexBasis: '70%'},
});

export default OligoMetadata;
